"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

export function LogoutButton({
  tone = "light",
  redirectTo = "/login",
  className,
}: {
  tone?: "light" | "dark";
  redirectTo?: string;
  className?: string;
}) {
  const router = useRouter();
  const [pending, setPending] = useState(false);

  async function logout() {
    setPending(true);
    await fetch("/api/auth/logout", { method: "POST" });
    router.push(redirectTo);
    router.refresh();
  }

  const toneClass =
    tone === "dark"
      ? "w-full rounded-xl border border-[#f6d7dd]/25 px-3 py-2 text-sm text-[#f6d7dd] hover:bg-white/10 disabled:opacity-60"
      : "rounded-full border border-line bg-white px-3 py-1.5 text-sm hover:bg-blush disabled:opacity-60";

  return (
    <button type="button" onClick={logout} disabled={pending} className={className ?? toneClass}>
      {pending ? "Signing out" : "Sign out"}
    </button>
  );
}
